import { Component, ViewChild, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { CampaignController,TargetingController } from '@Workspace/_generated/services';
import { IGoogleGeoTargetDto, IGoogleDmaDto, IGeographicTargetingJson, IGeographicDialogDataDto, ISelectItem, IBaseCampaignDto } from '@Workspace/_generated/interfaces';
import { Subject, BehaviorSubject } from 'rxjs';
import { debounceTime, subscribeOn, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { eAccountType } from '@Workspace/_generated/enums';

@Component({
    selector: 'advertiser-dialog',
    templateUrl: './advertiser-dialog.component.html',
    styleUrls: ['./advertiser-dialog.component.scss']
})
export class AdvertiserDialog implements OnInit {

    isVisible: boolean = false;
    canSave: boolean = true;
    advertiserId: any;
    advertiserName: string = '';
    ttdadvertiserId: string;
    dv360advertiserId: number;
    gamadvertiserId: number;
    metaAdAccountId: any;
    metaAdAccountName: string;
    defaultValues: any;
    metaDefaultValues: any;
    editableFields: boolean[] = [];
    header: string;
    landingPageUrl: string;
    campaignType: eAccountType;
    isLoading: boolean = false;
    isAdAccountIdValid: boolean = true;
    constructor(
        public campaignController: CampaignController, 
) { }
    isAdveriserIdEnteredInHub : boolean;
    isDv360AdveriserIdEnteredInHub : boolean;
    isTTDAdveriserIdEnteredInHub : boolean;
    isGAMAdveriserIdEnteredInHub: boolean;  
    enumAccountType = eAccountType;
    overrideGCMAdvertiserId: any;
    overrideTTDAdvertiserId: string;
    overrideDV360AdvertiserId: number;
    overrideGAMAdvertiserId: number;
    overrideMetaAdAccountId: string;
    overrideMetaAdAccountName: string;
    @Input() baseCampaignId : string;
    @Input() sponsorId: string;
    isMetaAdAccountIdEnteredInHub: boolean;
   

    ngOnInit() {

    }

    @Output('onSave') onSave: EventEmitter<any> = new EventEmitter<any>();

    private ngUnsubscribe = new Subject();

    openDialog(value: any, header: string, editable: any[], campaignType: eAccountType, advertiserName: string, 
        ttdAdvertiserId: string = null, dv360AdvertiserId: number = null, gamadvertiserId: number = null, gcmAdvertiserId:number = null,
        overridegcmadvertiserId: number = null, overridettdAdvertiserId: string = null, overridedv360AdvertiserId: number = null, overridegamadvertiserId: number = null,
        isAdveriserIdEnteredInHub: boolean = null, isDv360AdveriserIdEnteredInHub: boolean = null, isTTDAdveriserIdEnteredInHub: boolean = null, isGAMAdveriserIdEnteredInHub: boolean = null, 
        metaAdAccountId: any = null, isMetaAdAccountIdEnteredInHub: boolean = null, overridemetaadaccountId: string = null, metaAdAccountName: string = null, overridemetaadaccountName: string = null) 
    {
        this.defaultValues = { ...arguments };
        this.header = header;

        if(header == 'Advertiser') {
            this.advertiserName = advertiserName;
            this.canSave = true;
            if(campaignType == eAccountType.FAN365 || campaignType == eAccountType.HMP || campaignType == eAccountType.HS || campaignType == eAccountType.Social){
                this.isAdveriserIdEnteredInHub = isAdveriserIdEnteredInHub;
                this.isDv360AdveriserIdEnteredInHub = isDv360AdveriserIdEnteredInHub;
                this.isTTDAdveriserIdEnteredInHub = isTTDAdveriserIdEnteredInHub;
                this.advertiserId = gcmAdvertiserId;
                this.ttdadvertiserId = ttdAdvertiserId;
                this.dv360advertiserId =  dv360AdvertiserId;
                this.overrideGCMAdvertiserId = overridegcmadvertiserId != null ? overridegcmadvertiserId : "";
                this.overrideTTDAdvertiserId = overridettdAdvertiserId != null ? overridettdAdvertiserId : "";
                this.overrideDV360AdvertiserId = overridedv360AdvertiserId != null ? overridedv360AdvertiserId : null;
                this.isMetaAdAccountIdEnteredInHub = isMetaAdAccountIdEnteredInHub;
                this.overrideMetaAdAccountId = this.isMetaAdAccountIdEnteredInHub ? overridemetaadaccountId : "";
                this.metaAdAccountId = metaAdAccountId;
                this.metaAdAccountName = metaAdAccountName;
                this.overrideMetaAdAccountName = this.isMetaAdAccountIdEnteredInHub ? overridemetaadaccountName : "";
            }
            else if(campaignType == eAccountType.OAS){
                this.isAdveriserIdEnteredInHub = isAdveriserIdEnteredInHub;
                this.isGAMAdveriserIdEnteredInHub = isGAMAdveriserIdEnteredInHub;
                this.advertiserId = gcmAdvertiserId;
                this.gamadvertiserId = gamadvertiserId;
                this.overrideGCMAdvertiserId = overridegcmadvertiserId != null ? overridegcmadvertiserId : "";
                this.overrideGAMAdvertiserId = overridegamadvertiserId != null ? overridegamadvertiserId : null;

            }
            // else if(campaignType == eAccountType.Social){
            //     this.isMetaAdAccountIdEnteredInHub = isMetaAdAccountIdEnteredInHub;
            //     this.metaAdAccountId = metaAdAccountId;
            //     this.overrideMetaAdAccountId = this.isMetaAdAccountIdEnteredInHub ? overridemetaadaccountId : "";
            // }
        } else {
            this.landingPageUrl = value;

        }
        this.editableFields = arguments[3];
        this.isVisible = true;
        this.campaignType = campaignType;

    }
    
    openMetaAdAccountDialog(header: string, campaignType: eAccountType, metaAdAccountId: any = null, metaAdAccountName: string = null, isMetaAdAccountIdEnteredInHub: boolean = null,
         overridemetaadaccountId: string = null, overridemetaadaccountName: string = null){
        this.metaDefaultValues = { ...arguments };
        this.header = header;
        this.metaAdAccountId = metaAdAccountId;
        this.metaAdAccountName = metaAdAccountName;
        this.overrideMetaAdAccountId = overridemetaadaccountId;
        this.overrideMetaAdAccountName = overridemetaadaccountName;
        this.isMetaAdAccountIdEnteredInHub = isMetaAdAccountIdEnteredInHub;
        this.canSave = true;
        
        this.isVisible = true;
        this.campaignType = campaignType;
    }

    resetDefault() {
        if(this.header == 'Meta Ad Account') {
            this.metaAdAccountId = this.metaDefaultValues[2];
            this.overrideMetaAdAccountId = this.metaDefaultValues[5];
            this.metaAdAccountName = this.metaDefaultValues[3];
            this.overrideMetaAdAccountName = this.metaDefaultValues[6];
        }
        else if (this.header == 'Advertiser') {
             this.advertiserId = this.defaultValues[0];
            this.ttdadvertiserId = this.defaultValues[5];
            this.dv360advertiserId = this.defaultValues[6];
            this.overrideGCMAdvertiserId = this.defaultValues[9];
            this.overrideTTDAdvertiserId = this.defaultValues[10];
            this.overrideDV360AdvertiserId =this.defaultValues[11];
            this.metaAdAccountId = this.defaultValues[17];
            this.overrideMetaAdAccountId = this.defaultValues[19];
            this.metaAdAccountName = this.defaultValues[20];
            this.overrideMetaAdAccountName = this.defaultValues[21];
        } else {
            this.landingPageUrl = this.defaultValues[0];

        }


    }

    save() {
        if(this.header == 'Meta Ad Account'){
            const dialogResult = {
                dialogType: 'metaAdAccount',
                metaAdAccountId: this.metaAdAccountId,
                metaAdAccountName: this.metaAdAccountName,
                isMetaAdAccountIdEnteredInHub: this.isMetaAdAccountIdEnteredInHub,
                overridemetaadaccountId: this.overrideMetaAdAccountId,
                overridemetaadaccountName: this.overrideMetaAdAccountName,
                isOverrided: true
            };
            this.onSave.emit(dialogResult);
        }
        else if (this.header == 'Advertiser') {
            const dialogResult = {
                dialogType: 'advertiser',
                advertiserId:  this.advertiserId,
                overridegcmadvertiserId: this.overrideGCMAdvertiserId ?? '',
                advertiserName: this.advertiserName,
                ttdadvertiserId: this.ttdadvertiserId,
                overridettdadvertiserId: this.overrideTTDAdvertiserId,
                dv360advertiserId: this.dv360advertiserId,
                overridedv360advertiserId: this.overrideDV360AdvertiserId,
                gamadvertiserId: this.gamadvertiserId,
                overridegamadvertiserId :this.overrideGAMAdvertiserId,
                isAdveriserIdEnteredInHub : this.isAdveriserIdEnteredInHub,
                isDv360AdveriserIdEnteredInHub : this.isDv360AdveriserIdEnteredInHub,
                isTTDAdveriserIdEnteredInHub : this.isTTDAdveriserIdEnteredInHub,
                isGAMAdveriserIdEnteredInHub: this.isGAMAdveriserIdEnteredInHub,
                metaAdAccountId: this.metaAdAccountId,
                metaAdAccountName: this.metaAdAccountName,
                isMetaAdAccountIdEnteredInHub: this.isMetaAdAccountIdEnteredInHub,
                overridemetaadaccountId: this.overrideMetaAdAccountId,
                overridemetaadaccountName: this.overrideMetaAdAccountName,
                isOverrided: true
            };
            this.onSave.emit(dialogResult);

        } else {
            const dialogResult = {
                landingPageUrl: this.landingPageUrl,
            };
            this.onSave.emit(dialogResult);

        }
        this.isVisible = false;
    }

    cancel() {
        this.isVisible = false;
    }

    onChangeGCMAdvertiserId(){
        this.isAdveriserIdEnteredInHub = !(this.overrideGCMAdvertiserId == null);
    }

    onChangeTTDAdvertiserId(){
        this.isTTDAdveriserIdEnteredInHub = !(this.overrideTTDAdvertiserId == null || this.overrideTTDAdvertiserId == "");
    }

    onChangeDV360AdvertiserId(){
        this.isDv360AdveriserIdEnteredInHub = !(this.overrideDV360AdvertiserId == null);
    }

    onChangeGAMAdvertiserId(){
        this.isGAMAdveriserIdEnteredInHub = !(this.overrideGAMAdvertiserId == null);
    }

    onChangeMetaAdAccountId(){
        this.isMetaAdAccountIdEnteredInHub = !(this.overrideMetaAdAccountId == null || this.overrideMetaAdAccountId == "");
    }
    
    onChangeMetaAdAccountName(){
        this.isMetaAdAccountIdEnteredInHub = !(this.overrideMetaAdAccountName == null || this.overrideMetaAdAccountName == "");
    }

    validateLandingPage() {
        if (!!this.landingPageUrl) {
            let textToMacth = this.landingPageUrl;
            // var regex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:\/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
            var regex = /^[a-zA-Z0-9]+[^.\n]*[.][^.\n]+([.][^.\n]+)*$/;
            var found = textToMacth.match(regex);
            if (found != null) {
                this.canSave = true;
            }

            else {
                this.canSave = false;
            }
        }
    }
    createAdvertiser(){
        this.isLoading = true;
        this.campaignController.CreateAdvertiser(this.baseCampaignId).subscribe(
            (val) => {
                if (val && val['StatusCode'] === 500) {
                    alert("Error: " + val['Message']);
                } else {
                    alert("Result: " + JSON.stringify(val));
                }
                this.isLoading = false;
                
                this.campaignController.GetSponsorById(this.sponsorId).subscribe(async data => {
                    this.advertiserId = data.gcmAdvertiserId;
                    this.ttdadvertiserId = data.ttdAdvertiserId;
                    this.dv360advertiserId = data.dV360AdvertiserId;
                    this.gamadvertiserId = data.gamAdvertiserId;
                    const dialogResult = {
                        dialogType: 'advertiser',
                        advertiserId: this.overrideGCMAdvertiserId == "" || this.overrideGCMAdvertiserId == null ? this.advertiserId : this.overrideGCMAdvertiserId,
                        advertiserName: this.advertiserName,
                        ttdadvertiserId: this.overrideTTDAdvertiserId == "" || this.overrideTTDAdvertiserId == null ? this.ttdadvertiserId : this.overrideTTDAdvertiserId,
                        dv360advertiserId:  this.overrideDV360AdvertiserId == null ? this.dv360advertiserId : this.overrideDV360AdvertiserId,
                        gamadvertiserId: this.overrideGAMAdvertiserId == null ? this.gamadvertiserId : this.overrideGAMAdvertiserId,
                        isAdveriserIdEnteredInHub : this.isAdveriserIdEnteredInHub,
                        isDv360AdveriserIdEnteredInHub : this.isDv360AdveriserIdEnteredInHub,
                        isTTDAdveriserIdEnteredInHub : this.isTTDAdveriserIdEnteredInHub,
                        isGAMAdveriserIdEnteredInHub: this.isGAMAdveriserIdEnteredInHub,
                        isOverrided: false
                    };
                    this.onSave.emit(dialogResult);
                });
            },
            (error) => {  
                alert("Error: " + (error.message || JSON.stringify(error)));
                this.isLoading = false;  
                this.isVisible = false;
            }
        );
    }

    validateAdAccountId() {
        const formattedAdAccountId = this.overrideMetaAdAccountId?.trim()?.replace(/^act_/, '');
        this.isAdAccountIdValid = /^\d{10,}$/.test(formattedAdAccountId?.trim());
    }

}